import querystring from 'query-string';
import { jobDetails, recommendations } from './mock-overrides';
import { apacSavedSearches } from './savedSearchMock';

const resolverOverrides = () => (_mockStore: any) => {
  const { testData = '' } =
    typeof window !== 'undefined'
      ? querystring.parseUrl(window.location.href).query
      : {};

  return {
    CreateSavedJobPayload: {
      __resolveType: () => 'CreateSavedJobSuccess',
    },
    DeleteSavedJobPayload: {
      __resolveType: () => 'DeleteSavedJobSuccess',
    },
    JobProducts: {
      __resolveType: (arg0: any) => arg0.__typename,
    },
    Recommendations: {
      recommendedGlobalJobs: (_: any, args: any) => {
        if (testData === 'GRAPH_ERROR_RECS') {
          return new Error('CANDIDATE_GRAPH_ERROR_RECOMMENDATIONS');
        }

        return {
          ...recommendations!.recommendedGlobalJobs,
          globalJobs: recommendations!.recommendedGlobalJobs!.globalJobs.slice(
            0,
            args.limit,
          ),
        };
      },
    },

    IJobProfileSalaryMatch: {
      __resolveType: (arg0: any) => arg0.__typename,
    },

    Query: {
      jobDetails: (_: any, { id }: any) => jobDetails({ id }),
      viewer: (_: any) => apacSavedSearches,
    },
    Mutation: {
      createSavedJob2: (_: any, { input }: any) => ({
        __typename: 'CreateSavedJobSuccess',
        id: input.id,
      }),
      deleteSavedJob2: (_: any, { input }: any) => ({
        __typename: 'DeleteSavedJobSuccess',
        id: input.id,
      }),
      reportJob: (_: any, __: any) => ({
        __typename: 'ReportJobPayload',
        success: testData !== 'GRAPH_ERROR_CREATE_REPORTED_JOB_AD',
      }),
    },
  };
};

export default resolverOverrides;
